import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import "./VoucherCard.css";

export class EventVoucher extends Component {
  state = {
    step: 1,
    showConfirm: false,
    showLocation: false,
    loading: true,
    booking_list : null,
    sub_event : null,
  };

  async componentDidMount() {
      const { event, gms_id } = this.props;
      const church_event_ids = event.sub_event.map(item => item.id);
      const now = new Date();
      const voucher_claim_deadline = new Date("2025-12-01T22:00:00");
      const voucher_expired_deadline = new Date("2025-12-15T22:00:00");

      try {

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}is_registered_booking_list`,
        {
          gms_id,
          church_event_ids,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      
      if(response.data?.data?.booking_list){
        this.setState({
          sub_event: response.data?.data?.sub_event,
          booking_list: response.data?.data?.booking_list
        });
      }
      
      let step = 1;
      
      if(!gms_id){
        step = 94;
      }
      else if (now > voucher_expired_deadline && response.data?.data?.booking_list?.status !== 'used') {
        step = 93;
      }
      else if (now > voucher_claim_deadline && !response.data?.data?.booking_list) {
        step = 92;
      }
      else if(response.data?.data?.is_voucher_depleted){
        step = 91;
      }
      else if(response.data?.data?.booking_list?.status === 'used'){
        step = 3;
      } else if(response.data?.data?.booking_list){
        step = 2;
      }

      this.setState({
        step: step,
        loading: false,
      });
      } catch (error) {
        console.error("Error checking registration:", error);

        this.setState({
          step: 1,
          loading: false,
        });
      }
    }

  handleNextStepOne = async () => {
    this.setState({
      loading: true,
    });

    const { event, gms_id } = this.props;
    const church_event_ids = event.sub_event.map(item => item.id);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}add_participant_to_booking_list`,
        {
          gms_id,
          church_event_ids,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if(response.data?.data?.booking_list){
        this.setState({
          sub_event: response.data?.data?.sub_event,
          booking_list: response.data?.data?.booking_list,
          step: 2,
          loading: false,
        });
      }
      else{
        this.setState({
          step: 91,
          loading: false,
        });
      }
    } catch (error) {
      console.error("Error saving booking:", error);
    }
  };

  handleNextStepTwo = async () => {
    this.setState({
      loading: true,
    });

    const participant_id = this.state.booking_list.participant_id;
    const church_event_id = this.state.booking_list.church_event_id;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}redeem_voucher`,
        {
          participant_id,
          church_event_id
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      
      this.setState({
        booking_list: response.data?.data?.booking_list,
        step: 3,
        loading: false,
      });
    } catch (error) {
      console.error("Error saving booking:", error);
    }
  };

  render() {
    const { step, showConfirm, showLocation, sub_event, booking_list } = this.state;
    const { nij } = this.props;

    const fullImageUrl = `${process.env.PUBLIC_URL}/img/voucher_logo.png`;
    const logoGmsUrl = `${process.env.PUBLIC_URL}/img/logo_gms.png`;
    const warningImageUrl = `${process.env.PUBLIC_URL}/img/voucher_warning.png`;
    const redeemedImageUrl = `${process.env.PUBLIC_URL}/img/voucher_redeemed.png`;

    const listTenants = [
      {
        name: "Gococo",
        location: [
          'Pakuwon City Mall'
        ],
      },
      {
        name: "ZaMiruku",
        location: [
          'Grand City Mall'
        ],
      },
      {
        name: "Cincau Station",
        location: [
          'Berlaku di semua cabang Cincau Station Surabaya',
        ],
      },
      {
        name: "Ejji Coffee Corner",
        location: [
          'Berlaku di semua cabang Ejji Coffe Corner Surabaya',
          'Ejji Pondok Tjandra'
        ],
      },
      {
        name: "Helden Coffee",
        location: [
          'Pakuwon Mall'
        ],
      },
      {
        name: "eir coffee",
        location: [
          'Pakuwon Mall',
          'Tunjungan Plaza',
          'Park Shanghai Pakuwon City Mall'
        ],
      },
      {
        name: "Kawanua es",
        location: [
          'Pakuwon Mall',
          'Pakuwon CIty Mall'
        ],
      },
      {
        name: "Get Tea",
        location: [
          'Pakuwon Mall',
          'Pakuwon City Mall',
          'Tunjungan Plaza',
          'Loop'
        ],
      },
    ];

    let tenantData = [];
    let voucherImage = "";
    if(this.state.sub_event){
      const exploded = this.state.sub_event.name.split(" - ");
      const tenantName = exploded[0];
      tenantData = listTenants.find((item) => item.name === tenantName);
      voucherImage = "/img/tenant_logo/" + tenantName +".png"
    }

    if (this.state.loading) {
      return (
        <div style={{ textAlign: "center", padding: "50px" }}>
          <div className="spinner-border" role="status">
          </div>
          <p className="mt-2">Memeriksa data voucher...</p>
        </div>
      );
    }

    return (
      <div style={containerStyle}>
        {/* STEP 1 */}

        {step === 1 && (
          <div style={cardStyle}>
            <img
              src={fullImageUrl}
              alt="Voucher"
              style={{ maxWidth: "120px" }}
              className="mx-auto d-block mb-3"
            />

            <h4 className="d-flex justify-content-start">
              Dear
            </h4>
            <h4 className="d-flex justify-content-start">
              <strong>GMS Volunteers</strong>
            </h4>

            <p style={captionStyle2} className="my-3">
              Here's a little surprise for you 
              <br />
              because we love you and 
              <br />
              appreciate you
            </p>

            <p className="my-3 text-danger">
              Batas claim voucher:
              <br />
              <strong>1 Desember 2025, 22:00 WIB</strong>
            </p>

            <div style={containerButtonStyle}>
              <button
                className="btn btn-primary w-75 py-2 fw-semibold rounded-pill"
                onClick={this.handleNextStepOne}
              >
                Claim Voucher
              </button>
            </div>

            <p style={captionStyle2} className="my-3">
              Happy Volunteers Day!
            </p>
            <img
              src={logoGmsUrl}
              alt="Logo GMS"
              style={{ maxWidth: "80px", display: "block", marginLeft: "auto",marginRight: "10px", transform: "rotate(-15deg)"}}
              className="mb-3"
            />
          </div>
        )}

        {/* STEP 2 */}
        {step === 2 && (
          <div style={cardStyle}>
            <img
              src={fullImageUrl}
              alt="Voucher"
              style={{ maxWidth: "120px" }}
              className="mx-auto d-block mb-3"
            />

            <h3 style={titleStyle} className="mt-5">
              Selamat, Anda Mendapatkan 
            </h3>

            <div className="voucher-card my-5">
              <div className="voucher-logo">
                <img src={voucherImage} alt={'Logo'} />
              </div>

              <div className="voucher-info">
                <h3 className="voucher-name">{sub_event.name}</h3>
                <p className="voucher-valid">{sub_event.booking_rule}</p>
                <button
                  className="btn btn-link p-0 text-primary"
                  onClick={() => this.setState({ showLocation: true })}
                >
                  Lihat Lokasi Penukaran
                </button>
              </div>
            </div>

            <p className="my-3 text-danger">
              Batas redeem voucher:
              <br />
              <strong>15 Desember 2025, 22:00 WIB</strong>
            </p>

            <p style={captionStyle} className="text-danger">
              Penukaran hanya dapat dilakukan sekali dan <strong>hanya oleh pihak merchant.</strong> Anda yakin ingin gunakan voucher sekarang?
            </p>

            <div className="card shadow-sm border-light p-3" style={{ borderRadius: "10px" }}>
              <div className="d-flex justify-content-between mb-2">
                <span>Kode Voucher</span>
                <span style={{ fontWeight: "bold" }}>{((booking_list.code).slice(-8)).toUpperCase()}</span>
              </div>

              <div className="d-flex justify-content-between">
                <span>NIJ</span>
                <span style={{ fontWeight: "bold" }}>{nij}</span>
              </div>
            </div>

            <div className="d-flex flex-column align-items-center gap-3 mt-4">
              <button
                className="btn btn-primary w-75 py-2 fw-semibold rounded-pill"
                onClick={() => this.setState({ showConfirm: true })}
              >
                Redeem Voucher
              </button>
            </div>
          </div>
        )}

        {/* STEP 3 */}
        {step === 3 && (
          <div style={cardStyle}>
            <img
              src={redeemedImageUrl}
              alt="Redeemed"
              className="mx-auto d-block mb-3"
              style={{ maxWidth: "200px" }}
            />

            <h3 style={titleStyle} >
              Voucher Berhasil Ditukarkan✅
            </h3>

            <div className="voucher-card my-5">
              <div className="voucher-logo">
                <img src={voucherImage} alt={'Logo'} />
              </div>

              <div className="voucher-info">
                <h3 className="voucher-name">{sub_event.name}</h3>
                <p className="voucher-valid">{sub_event.booking_rule}</p>
              </div>
            </div>
          </div>
        )}

        {/* STEP 91 [VOUCHER HABIS] */}
        {step === 91 && (
          <div style={cardStyle}>
            <img
              src={fullImageUrl}
              alt="Voucher"
              style={{ maxWidth: "120px" }}
              className="mx-auto d-block mb-3"
            />

            <h3 style={titleStyle} >
              Mohon maaf, kuota voucher sudah habis. Kami berterimakasih atas pelayanan Anda, Tuhan memberkati.
            </h3>
          </div>
        )}

        {/* STEP 92 [WAKTU CLAIM VOUCHER BERAKHIR] */}
        {step === 92 && (
          <div style={cardStyle}>
            <img
              src={fullImageUrl}
              alt="Voucher"
              style={{ maxWidth: "120px" }}
              className="mx-auto d-block mb-3"
            />

            <h3 style={titleStyle} >
              Mohon maaf, periode pengambilan Appreciation Gift telah berakhir. Kami berterimakasih atas pelayanan Anda, Tuhan memberkati.
            </h3>
          </div>
        )}

        {/* STEP 93 [VOUCHER KADALUARSA] */}
        {step === 93 && (
          <div style={cardStyle}>
            <img
              src={fullImageUrl}
              alt="Voucher"
              style={{ maxWidth: "120px" }}
              className="mx-auto d-block mb-3"
            />

            <h3 style={titleStyle} >
              Mohon maaf, Voucher Anda telah kadaluarsa pada tanggal 15 Des 2025. Kami berterimakasih atas pelayanan Anda, Tuhan memberkati.
            </h3>
          </div>
        )}

        {/* STEP 94 [GMS_ID / PARTICIPANT NOT FOUND] */}
        {step === 94 && (
          <div style={cardStyle}>
            <img
              src={fullImageUrl}
              alt="Voucher"
              style={{ maxWidth: "120px" }}
              className="mx-auto d-block mb-3"
            />

            <h3 style={titleStyle} >
              Mohon maaf, Data Tidak ditemukan.
            </h3>
          </div>
        )}
        {/* MODAL CONFIRMATION */}
        <div
          className={`modal fade ${showConfirm ? "show d-block" : ""}`}
          style={{ backgroundColor: "rgba(0,0,0,0.4)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-sm">
            <div className="modal-content p-3 text-center rounded-4" style={{
              maxHeight: "80vh",
              overflowY: "auto"
            }}>
              <button
                className="btn align-self-end"
                onClick={() => this.setState({ showConfirm: false })}
              >
                ✕
              </button>

              <img
                src={warningImageUrl}
                alt="Voucher Confirm"
                style={{ maxWidth: "200px" }}
                className="mx-auto mt-2"
              />

              <p className="mt-3 fw-semibold">
                Apakah anda yakin ingin menukarkan voucher?
              </p>

              <div className="alert alert-warning rounded-4 mt-2 text-start">
                <strong>Perhatian:</strong><br />
                Halaman ini harus ditunjukkan ke tenant agar tenant dapat mencatat atau memverifikasi kode voucher sebelum melakukan redeem.
              </div>

              <button
                className="btn btn-primary rounded-pill w-100 mt-2"
                onClick={() => {
                  this.setState({ showConfirm: false });
                  this.handleNextStepTwo();
                }}
              >
                Redeem Voucher
              </button>

              <button
                className="btn btn-outline-primary rounded-pill w-100 mt-2"
                onClick={() => this.setState({ showConfirm: false })}
              >
                Back
              </button>
            </div>
          </div>
        </div>
        {/* MODAL LOKASI PENUKARAN */}
        <div
          className={`modal fade ${showLocation ? "show d-block" : ""}`}
          style={{ backgroundColor: "rgba(0,0,0,0.4)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content p-3 text-start rounded-4" style={{
              maxHeight: "80vh",
              overflowY: "auto"
            }}>

                {/* Close Icon */}
                <button
                  className="btn align-self-end"
                  onClick={() => this.setState({ showLocation: false })}
                >
                  ✕
                </button>

                {/* Title */}
                <h3 className="fw-semibold mb-2">Lokasi Penukaran</h3>

                {/* List Lokasi */}
                <ul className="text-start">
                  {tenantData?.location?.map((loc, idx) => (
                    <li key={idx}>{loc}</li>
                  ))}
                </ul>

                {/* Buttons */}
                <button
                  className="btn btn-outline-primary rounded-pill w-100 mt-3"
                  onClick={() => this.setState({ showLocation: false })}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
      </div>
    );
  }
}

// PropTypes
EventVoucher.propTypes = {
  event: PropTypes.shape({
    name: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    sub_event: PropTypes.array.isRequired,
  }).isRequired,
  nij: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  voucher_code: PropTypes.string,
  gms_id: PropTypes.string.isRequired,
};

// Styles
const containerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100vh",
  flexDirection: "column",
  padding: "20px",
  backgroundColor: "#687451",
  fontFamily: "'Quicksand', sans-serif",
};

const cardStyle = {
  maxWidth: "450px",
  width: "100%",
  textAlign: "center",
  backgroundColor: "#fff",
  borderRadius: "16px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  padding: "30px 20px",
};

const containerButtonStyle = {
  margin: "25px 0px",
};

const titleStyle = {
  fontSize: "1.5rem",
  fontWeight: "600",
  marginBottom: "10px",
};

const captionStyle = {
  fontSize: "1rem",
  color: "#555",
  marginBottom: "25px",
};

const captionStyle2 = {
  fontSize: "1.25rem",
};


export default EventVoucher;
